const redirectErrors = new Set([
    'auth/requires-recent-login',
    'auth/user-not-found',
    'auth/id-token-expired',
    'auth/invalid-user-token',
    'auth/user-disabled',
    'auth/invalid-credential',
    'auth/multi-factor-info-not-found',
    'auth/invalid-multi-factor-session',
]);
export { redirectErrors };
